import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Message } from 'primeng/primeng';
import { AuthService } from './auth.service';
import { Errors } from "./shared/Errors";
import { Router } from '@angular/router';

@Injectable()
export class GlobalService {    
    messages: Message[] = [];
    msgs: Message[] = [];
    authServiceRef: AuthService
    constructor(private _http: Http, private _router: Router) { }    

    get(url: string): Observable<any> {
        return this._http.get(url);
    }

    post(url: string, model: any): Observable<any> {
        let body = JSON.stringify(model);        
        let headers = this.authServiceRef.GetAuthHeader();
        let options = new RequestOptions({ headers: headers });
        return this._http.post(url, body, options);
    }

    put(url: string, id: number, model: any): Observable<any> {
        let body = JSON.stringify(model);        
        let headers = this.authServiceRef.GetAuthHeader();
        let options = new RequestOptions({ headers: headers });
        return this._http.put(url + id, body, options);
    }

    delete(url: string, id: number): Observable<any> {        
        let headers = this.authServiceRef.GetAuthHeader();
        let options = new RequestOptions({ headers: headers });
        return this._http.delete(url + id, options);
    }

    extractData(response: Response) {        
        return<any>response.json();
    }

    handleError(error: Response) {                              
      if (error.status == 500) {
          return Observable.throw('500 Internal server error');
        }
        if (error.status == 403) {
          this._router.navigate(['/login']);
          return Observable.throw('403 ' + error.statusText);
        }
        if (error.status == 401) {
          this._router.navigate(['/login']);
          return Observable.throw('401 Authorization has been denied for this request.');
        }
        let errors = <Errors>error.json();        
        if (errors != null) {
            return Observable.throw(errors || 'Server error');
        }
        else {
            return Observable.throw(JSON.stringify(error.json()) || 'Server error');
        }        
    }    

    //To handle the popups 
    showMessage(title: string, text: string[], types: string, isFlatMsg: boolean = false) {
        if (!isFlatMsg) {
            this.messages = [];
            for (let txt of text) {
                this.messages.push({ severity: types, summary: title, detail: txt });
            }
        }
        else {
            this.msgs = [];
            for (let txt of text) {
                this.msgs.push({ severity: types, summary: title, detail: txt });
            }
        }        
    }

    showError(title: string, error: any, isFlatMsg: boolean = false) {
        let customError: Errors = <Errors>error;        
        if (typeof (customError.Message) !== "undefined") {
            if (customError.Message != null && customError.FieldErrors.length == 0) {
                this.showMessage(title, [customError.Message], 'error', isFlatMsg);
            }
            else if (customError.Message != null && customError.FieldErrors.length > 0){
                let errors =  [];                
                for (let fieldError of customError.FieldErrors) {
                    errors.push(fieldError.Message);
                }
                this.showMessage(customError.Message, errors, 'error', isFlatMsg);
            }
        }
        else {
            this.showMessage(title, [<string>error], 'error', isFlatMsg);        
        }
    }

    showDefaultError(title: string) {
        this.showMessage(title, ["There is some issue in processing records, please contact to system administrator!"], 'error');
    }

    showApiError(error: string) {
        this.showMessage("", [error], 'error');
    }

    showInfo(title: string, text: string) {
        this.showMessage(title, [text], 'info');
    }

    showWarning(title: string, text: string) {
        this.showMessage(title, [text], 'warn');
    }

    showSuccess(title: string, text: string, isFlatMsg: boolean = false) {
      this.showMessage(title, [text], 'success', isFlatMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/global.service.ts